import state from './state'
import mutations from './mutations'

export default {
  namespaced: true,
  state,
  mutations,
} 


// WEBPACK FOOTER //
// ./src/store/modules/app/index.js